import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';
import config from '../../../config';

import SignedUp from './SignedUp';
import SignUpForm2 from './SignUpForm2';
import CodeForm from './CodeForm';

class SignUpPage extends Component {
  state = {
    givenName: '',
    familyName: '',
    country: '',
    city: '',
    jobTitle: '',
    yearsExperience: '',
    email: '',
    password: '',
    passwordMatch: '',
    code: '',
    salon: '',
    isCodeValid: false,
    loading: false,
    error: '',
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.hasSignedUp === state.AUTH_UNKNOWN && nextProps.auth.hasSignedUp === state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        error: '',
      });
    } else if (nextProps.auth.error) {
      this.setState({
        loading: false,
        error: nextProps.auth.error.message,
      });
    }
  }

  handleChangePassword = e => {
    const { changePassword } = this.props;
    const { email, code, password } = this.state;
    e.preventDefault();
    changePassword(email.toLowerCase(), code, password);
  };

  handleSignIn = () => {
    const { history, locale } = this.props;
    history.push(`/${locale}/stylist/login`);
  };

  handleInputChange = type => e =>
    this.setState({
      [type]: e.target.value,
      loading: false,
      error: '',
    });

  handleCodeSubmit = e => {
    const { code } = this.state;
    e.preventDefault();

    this.setState(
      {
        loading: true,
      },
      () => {
        fetch(`${config.API}/verify`, {
          method: 'post',
          body: JSON.stringify({ code }),
        })
          .then(res => res.json())
          .then(res => {
            if (Object.prototype.hasOwnProperty.call(res, 'errors')) {
              this.setState({
                loading: false,
                error: 'Something went wrong, please try again.',
              });
            } else if (res.user[0]) {
              this.setState({
                isCodeValid: code,
                salon: res.user[0].salon,
                city: res.user[0].city,
                country: res.user[0].country,
                jobTitle: res.user[0].userType,
                loading: false,
                error: '',
              });
            } else {
              this.setState({
                isCodeValid: false,
                loading: false,
                error: 'The code is not valid, please try again.',
              });
            }
          });
      }
    );
  };

  handleSignUp = e => {
    e.preventDefault();
    const {
      email,
      password,
      familyName,
      givenName,
      country,
      city,
      jobTitle,
      yearsExperience,
      salon,
      isCodeValid,
    } = this.state;
    const UserAttributes = [
      {
        Name: 'custom:family_name',
        Value: familyName,
      },
      {
        Name: 'custom:given_name',
        Value: givenName,
      },
      {
        Name: 'custom:country',
        Value: country,
      },
      {
        Name: 'custom:city',
        Value: city,
      },
      {
        Name: 'custom:job_title',
        Value: jobTitle,
      },
      {
        Name: 'custom:years_experience',
        Value: yearsExperience,
      },
      {
        Name: 'custom:salon',
        Value: salon,
      },
      {
        Name: 'custom:code',
        Value: isCodeValid,
      },
    ];

    this.setState(
      {
        loading: true,
        error: '',
      },
      () => {
        this.props.signUp(email.toLowerCase(), password, UserAttributes);
      }
    );
  };

  isValidSignUpForm = () => {
    const {
      familyName,
      givenName,
      country,
      city,
      jobTitle,
      yearsExperience,
      email,
      password,
      passwordMatch,
    } = this.state;

    return (
      familyName.length >= 2 &&
      givenName.length >= 2 &&
      country.length > 0 &&
      city.length >= 2 &&
      jobTitle.length >= 2 &&
      yearsExperience.length >= 0 &&
      email.length > 0 &&
      password.length >= 2 &&
      passwordMatch === password
    );
  };

  isValidCodeForm = () => {
    const { code } = this.state;
    return code.length >= 6;
  };

  render() {
    const { locale, copy, auth } = this.props;
    const {
      givenName,
      familyName,
      country,
      city,
      jobTitle,
      yearsExperience,
      email,
      password,
      passwordMatch,
      code,
      isCodeValid,
      loading,
      error,
    } = this.state;
    return auth.hasSignedUp === state.AUTH_UNKNOWN ? (
      <Fragment>
        {isCodeValid ? (
          <SignUpForm2
            givenName={givenName}
            familyName={familyName}
            country={country}
            city={city}
            jobTitle={jobTitle}
            yearsExperience={yearsExperience}
            email={email}
            password={password}
            passwordMatch={passwordMatch}
            copy={copy}
            locale={locale}
            isValidSignUpForm={this.isValidSignUpForm}
            onSignUp={this.handleSignUp}
            onInputChange={this.handleInputChange}
            loading={loading}
            error={error}
          />
        ) : (
          <CodeForm
            code={code}
            copy={copy}
            locale={locale}
            isValidCodeForm={this.isValidCodeForm}
            onInputChange={this.handleInputChange}
            onCodeSubmit={this.handleCodeSubmit}
            loading={loading}
            error={error}
          />
        )}
      </Fragment>
    ) : (
      <SignedUp copy={copy} locale={locale} />
    );
  }
}

SignUpPage.defaultProps = {
  copy: {},
};

SignUpPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    hasSentCode: PropTypes.string,
    hasSignedUp: PropTypes.string,
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  changePassword: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolSignUpPage,
  locale: state.locale,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  signUp: (username, password, userAttributes) => dispatch(reducer.signUp(username, password, userAttributes)),
  init: () => dispatch(reducer.init()),
});

export default connect(mapState, mapDispatch)(SignUpPage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SignUpPage/SignUpPage.js